import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isConnected: false,
    currentTicketId: null,
    realtimeComments: {},
};

const techSupportChatSlice = createSlice({
    name: 'techSupportChat',
    initialState,
    reducers: {
        connectionStatusChanged: (state, action) => {
            state.isConnected = action.payload;
        },
        setCurrentTicket: (state, action) => {
            state.currentTicketId = action.payload;
        },
        commentReceived: (state, action) => {
            const comment = action.payload;
            const ticketId = comment.ticketId ?? comment.TicketId ?? state.currentTicketId;
            if (!ticketId) return;

            if (!state.realtimeComments[ticketId]) {
                state.realtimeComments[ticketId] = [];
            }
            const commentId = comment.commentId ?? comment.id ?? comment.CommentId ?? comment.Id;
            const exists = state.realtimeComments[ticketId].some(
                (c) => (c.commentId ?? c.id) === commentId
            );
            if (!exists) {
                state.realtimeComments[ticketId].push(comment);
            }
        },
        clearTicketComments: (state, action) => {
            const ticketId = action.payload;
            delete state.realtimeComments[ticketId];
        },
    },
});

export const {
    connectionStatusChanged,
    setCurrentTicket,
    commentReceived,
    clearTicketComments,
} = techSupportChatSlice.actions;

export const selectRealtimeComments = (ticketId) => (state) =>
    state.techSupportChat?.realtimeComments?.[ticketId] || [];

export const selectIsConnected = (state) => state.techSupportChat?.isConnected;

export default techSupportChatSlice.reducer;
